import React from "react";
import styled from "styled-components";

import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const Detail = () => {
     const navigate = useNavigate();
     const { id } = useParams();
     const Todos = useSelector((state) => state.Todos);
     const todo = Todos.filter((item) => item.id === Number(id));
     console.log(todo);

     return (
          <STdetail>
               <div>
                    <h3>ID : {id}</h3>
                    <button
                         onClick={() => {
                              navigate("/");
                         }}
                    >
                         이전으로
                    </button>
               </div>
               <h1>{todo[0].title}</h1>
               <p>{todo[0].body}</p>
          </STdetail>
     );
};

export default Detail;

const STdetail = styled.div`
     max-width: 1000px;
     min-width: 800px;
     height: 550px;
     padding: 20px;
     border: 5px solid #888;
     position: absolute;
     top: 50%;
     left: 50%;
     transform: translate(-50%, -50%);
     display: flex;
     flex-direction: column;
     justify-content: space-between;
     div {
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-between;
          font-size: 20px;
          padding: 25px;
          button {
               font-size: 22px;
               background-color: transparent;
               border: transparent;
               font-weight: 600;
               cursor: pointer;
          }
     }
     h1 {
          padding: 25px;
     }
     p {
          padding: 25px;
          height: 70%;
     }
`;
